import { IoChevronUpSharp } from "react-icons/io5";
import { useEffect, useState } from "react";

export default function Retroceder({ setColorbarra2, idComponente }) {
  const [retroceder, setRetroceder] = useState("none");

  const onScroll = () => {
    window.scroll(0, 0);

    if (idComponente !== 0) {
      setColorbarra2("barra2");
    }

    if (idComponente === 0 && window.scrollY === 0) {
      setColorbarra2("barra-secundaria");
    }

    window.onscroll = () => {
      const y = window.scrollY;

      if (idComponente === 0) {
        y > 0
          ? setColorbarra2("barra2-menú")
          : setColorbarra2("barra-secundaria");
      }

      y >= 400 ? setRetroceder("block") : setRetroceder("none");
    };
  };

  //valida donde está es scrroll para mostrar la opción de volver al principio de la página y adecuar la segunda barra del menú
  useEffect(() => {
    onScroll();
  }, [idComponente]);

  return (
    <>
      <a
        href="##"
        onClick={() => {
          window.scroll(0, 0);
        }}
        className="content-retroceder"
        style={{ display: retroceder }}
      >
        <IoChevronUpSharp />
      </a>
    </>
  );
}
